import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { observer } from "mobx-react-lite";
export const AppError = observer(({ error }) => {
    return (_jsx(_Fragment, { children: _jsx("div", { className: "container mt-5", children: _jsx("div", { className: "row", children: error.message }) }) }));
});
